<template>
<section class="section" @click="gotoDetail(goods)">
  <van-image :src="goods.mainImage+'?x-oss-process=style/750w-2'" width="4.5867rem" height="4.5867rem" lazy-load>
    <template v-slot:loading>
      <div class="loadingbg"></div>
    </template>
    <template v-slot:error>
      <div class="loadingbg"></div>
    </template>
  </van-image>
  <div class="goods_pwrap">

    <h4 class="goods_tit"><img class='pt_icon' v-if="goods.participantCount" src="@/assets/images/pt_icon.png" />{{goods.itemName}}</h4>
    <p class="goods_des">{{goods.itemFullName || goods.sellPoint}}</p>

    <div class="goods_price">
      <gprice :price="goods.participantCount ? goods.pintuanPrice : goods.salePrice" color="#FA4949" fsize="12px" isize="18px"></gprice>
      <span class="xiangscore" v-if="ntype=='newer' && goods.isIntegral=='1'"><img src="@/assets/images/score_dikou.png" /></span>
    </div>
    <p class="oldPrice">￥{{goods.marketPrice | formatMoney()}}</p>
  </div>
</section>
</template>
<script>
import gprice from './gprice'
export default {
  name: '',
  components:{
    gprice
  },
  props:{
    goods:{},
    ntype:{
      type:String,
      default:''
    },
    ctype:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      title: ''
    }
  },
  methods: {
    gotoDetail: function(goods) {
      let params = {
        saleSkuId: goods.itemId
      }
      if(this.ctype == 'feed'){
        this.sendStatics('event_feeds_click',{currentUrl:1,module:98,feedSite:this.fIndex})
      }
      if(this.ctype == 'search'){
        this.sendStatics('event_search_result_click',{currentUrl:28,module:73,feedSite:this.fIndex})
      }
      this.$navigateTo("detail",params)
    },
  }
}
</script>
<style scoped lang='less'>
.ssection{
  width: 4.5867rem;
  background: #fff;
  margin-bottom: 0.2667rem;
}

.goods_tit{
  word-break: break-all;
  font-size: 13px;
  line-height:18px;
  color: rgba(0, 0, 0, 0.86);
  font-family: PingFangSC-Medium, sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  i{
    display:inline-block;
    color:#fff;
    background: #FC5656;
    font-size:10px;
    em{
      font-style: italic;
    }
  }
}
.pt_icon{
  width: 1.04rem;
  height: 0.3733rem;
  margin-right: 0.1333rem;
}
.goods_des{
  font-size: 11px;
  color: rgba(0, 0, 0, 0.4);
  margin: 5px 0 14px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-height:14px;
  word-break: break-word;
}
.goods_pwrap{
  padding: 0.2667rem;
}
.goods_price{
  display: flex;
  align-items: baseline;
}
.xiangscore{
  margin-left: 5px;
}
.xiangscore img{
  width: 1.5733rem;
  height: 0.3733rem;
}
.oldPrice{
  color: rgba(0, 0, 0, 0.2);
  font-size:11px;
  text-decoration: line-through;
  margin-top: 5px;
}
.loadingbg{
  width: 4.5867rem;
  height: 4.5867rem;
  background: url('../assets/images/default_bg2x.png') no-repeat;
  background-size: 100% 100%;
}
</style>